import angular from 'angular';
import activeLoanList from './activeLoanList';

export default angular
  .module('contactLendingTab.scenes.activeListLoans', [])
  .component('activeLoanList', activeLoanList).name;
